module.exports = __webpack_public_path__ + "static/media/remove-icon.3561c28a.svg";